import Box from "pages/_components/Box";
import Button from "pages/_components/Button";
import Head from "pages/_components/Head";
import Image from "pages/_components/Image";
import MainContainer from "pages/_components/MainContainer";
import Text from "pages/_components/Text";
import { func, bool } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { selectors as sessionSelectors } from "reducers/session";

class TokenActivationSuccess extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        isLoggedIn: bool.isRequired,
    };

    close = () => {
        const { dispatch, isLoggedIn } = this.props;
        dispatch(push(isLoggedIn ? "/settings/authenticatorHandler" : "/"));
    };

    render() {
        return (
            <>
                <Head title="token.activation.title" hideNavbarInMobile additionalClassName="background-primary" />
                <MainContainer classNameMainWrapper="background-menu-background" showLoader={false}>
                    <Box
                        display="flex"
                        column
                        alignY="center"
                        background="white"
                        borderRadius="md"
                        className="mt-8 pb-10"
                        fullWidth>
                        <Text
                            component="h2"
                            size="4"
                            bold
                            align="center"
                            color="heading"
                            className="mx-9 my-8"
                            labelKey="token.activation.success.subtitle"
                        />
                        <Image className="mb-9" src="images/icons/successShield.svg" />
                        <Text
                            component="p"
                            align="center"
                            size="5"
                            color="heading"
                            className="mx-9 mb-12"
                            labelKey="token.activation.success.text1"
                        />
                    </Box>
                    <Box display="flex" column className="mt-auto" fullWidth>
                        <Button
                            label="token.activation.success.button.login"
                            bsStyle="primary"
                            onClick={this.close}
                            block
                        />
                    </Box>
                </MainContainer>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    isLoggedIn: sessionSelectors.isLoggedIn(state),
});

export default connect(mapStateToProps)(TokenActivationSuccess);
